/**
 * Samo putopis Valencia — tura „Valencia“ koristi privatne slike (VALENCIA_TOUR_GALLERY u valenciaTour.js).
 * 4.–7. slika: mapa Desktop/vale (ista imena u public/images/valencia/).
 */
export const VALENCIA_TRAVELOGUE_GALLERY = [
  "/images/valencia/1000177997.jpg",
  "/images/valencia/1000178273.jpg",
  "/images/valencia/1000205165.jpg",
  "/images/valencia/20240930_190447.jpg",
  "/images/valencia/20241003_144322.jpg",
  "/images/valencia/20250928_120500.jpg",
  "/images/valencia/20250928_182211.jpg",
  "/images/valencia/20240930_190447-1.jpg",
];

export const VALENCIA_TRAVELOGUE_VIDEOS = ["/videos/valencia/20241003_112247.mp4"];
